<template>
  <div class="page" v-cloak>
    <van-nav-bar :border="false" left-arrow fixed title="申请修理" class="user_service_nav_bar" @click-left="onClickLeft" :z-index="20" :style="'background: #2998FF; color:#FFFFFF;'"></van-nav-bar>

    <van-cell-group v-if="machine_id">
      <van-cell title="站点名称" :value="machine.station_name" />
      <van-cell title="设备编码" :value="machine.machine_code" />
    </van-cell-group>

    <van-checkbox-group v-model="result" style="margin-top: 30px;">
      <van-cell-group>
        <van-cell title="故障类型" />
        <van-cell v-for="(item, index) in list" clickable :key="item.key" :title="`${item.val}`" @click="toggle(index,item)">
          <template #right-icon>
            <van-checkbox :name="item" ref="checkboxes" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>

    <van-field style="margin-top: 30px;" v-model="repairContent" rows="2" autosize label="报修描述" type="textarea" maxlength="50" placeholder="请输入报修描述" show-word-limit />

    <van-field name="uploader" label="文件上传">
      <template #input>
        <van-uploader :after-read="afterRead" v-model="uploader" name="repairPic" multiple capture :max-count="1" />
      </template>
    </van-field>

    <van-button class="foot-btn" size="large" color="#3F7CFF" @click="submit">提交</van-button>

  </div>
</template> 

<script>
export default {
  name: "new-bind",
  components: {},
  props: {},
  data() {
    return {
      machine_id: this.$route.query.machineId || "",
      order_id: this.$route.query.orderId || "",
      machine: {},

      list: [],

      result: [],

      repairContent: "",

      uploader: [],
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.$toast.loading();
    if (this.machine_id) {
      this.get_machine();
    }
    this.getcofig();
  },
  methods: {
    toggle(index, item) {
      console.log(item);
      this.$refs.checkboxes[index].toggle();

      item.checked = !item.checked;

      console.log(this.list);
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
    },
    // 初始化数据
    get_machine() {
      let _this = this;
      let data = {
        machine_id: _this.machine_id,
      };
      _this.$post("/api/get_machine", data, data).then((res) => {
        console.log(res.data, "底部table");
        if (res.data && res.data.code == 0) {
          this.machine = res.data.data.machine;
          this.$toast.clear();
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    getcofig() {
      let _this = this;
      let data = {
        key: "RepairReason", //保修原因
      };
      _this.$post("/api/wash_config", data, data).then((res) => {
        console.log(res);
        this.$toast.clear();
        if (res.data.code == 0) {
          console.log(res.data.data);

          var list = res.data.data;
          var array = [];
          array = Object.keys(list).map((val) => ({
            key: val,
            val: list[val],
            checked: false,
          }));
          console.log(array);

          _this.list = array;
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },

    submit() {
      var that = this;
      // if (!/^1[3456789]\d{9}$/.test(that.phone)) {
      //   this.$toast.fail("请填写正确的手机号！");
      //   return;
      // }

      let repairReason = [];
      this.list.map((item, index) => {
        if (item.checked == true) {
          repairReason.push(item.key);
        }
      });

      // if (!that.repairContent) {
      //   this.$toast.fail("报修描述不可为空！");
      //   return;
      // }
      if (repairReason.length < 1) {
        this.$toast.fail("请选择报修原因！");
        return;
      }
      // if (that.uploader.length < 1) {
      //   this.$toast.fail("请上传故障照片！");
      //   return;
      // }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      // console.log(that.uploader);
      // console.log(that.uploader[0]);
      // console.log(that.uploader[0].file);

      let formData = new FormData();
      //通过append追加数据

      if (that.uploader[0] && that.uploader[0].file) {
        console.log("有值1");
        formData.append("repairPic", [that.uploader[0].file]);
      }
      if (that.repairContent) {
        formData.append("repairContent", that.repairContent);
      }

      formData.append("order_id", that.order_id);
      formData.append("repairReason", repairReason.join(","));

      // let data = {
      //   order_id: that.order_id, // 订单id, //
      //   repairReason: repairReason.join(","), //报修原因
      //   repairContent: that.repairContent || undefined, //报修描述, //
      //   repairPic: that.uploader[0] ? that.uploader[0].file : [], //图片
      // };
      let data = {
        order_id: that.order_id, // 订单id, //
        repairReason: repairReason.join(","), //报修原因
      };
      if (that.repairContent) {
        data = Object.assign(data, { repairContent: that.repairContent });
      }
      if (that.uploader[0] && that.uploader[0].file) {
        console.log("有值2");
        data = Object.assign(data, { repairPic: [that.uploader[0].file] });
      }

      console.log(data);
      this.$postForm("/api/repair_save", formData, data).then((res) => {
        console.log(res.data.data);
        if (res.data &&res.data.code == 0) {
          // that.$toast.clear(); //关闭弹窗
          that.$toast({ message: "提交成功~" });
          //
          if (that.machine_id) {
            that.wash_end();
          } else {
            setTimeout(function () {
              that.$router.go(-1);
              // 这里就是处理的事件
            }, 2000);
          }
        } else {
          that.$toast.fail(res.data.message);
        }
      });
    },
    wash_end() {
      let _this = this;
      _this.$post("/api/wash_end").then((res) => {
        console.log(res.data, "底部table");
        if (res.data && res.data.code == 0) {
          // this.str = "00:00:00";

          setTimeout(function () {
            _this.$router.replace({
              name: "wash-result",
              query: {
                orderId: _this.order_id,
              },
            });
            // 这里就是处理的事件
          }, 2000);
        } else {
          // _this.$toast.fail(res.data.message);
        }
      });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.user_service_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
</style>

<style lang="scss" scoped>
.page {
  width: 100%;
  padding: 50px 0;
  text-align: left;
  background-color: #f7f7f7;
  h3 {
    text-align: left;
    margin-top: 70px;
    padding-left: 30px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 61px;
    color: #2a2e43;
  }
  .top-tips {
    text-align: left;
    padding-left: 38px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 30px;
    color: #999999;
  }
  .centers {
    margin-top: 50px;
    padding: 0 38px;
    .input-tips {
      margin-top: 10px;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 23px;
      color: #999999;
      text-align: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .input-success {
        display: inline-block;
        width: 18px;
        height: 18px;
        font-size: 18px;
        color: #3f7cff;
      }
    }
    .code-input {
      // margin: 100px 0;
      width: 100%;
      box-sizing: border-box;
      height: 44px;
      border-bottom: solid 1px #cccccc;
      display: flex;
      justify-content: space-between;
      input {
        width: 70%;
        height: 100%;
        text-align: left;
        background: none;
        outline: none;
        border: none;
        font-size: 18px;
      }
      .code-btn {
        width: 80px;
        height: 25px;
        border: 1px solid #999999;
        opacity: 1;
        border-radius: 5px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 21px;
        color: #999999;
      }

      .arr_icon {
        border: 1px solid #3f7cff;
        color: #3f7cff;
      }
    }
  }
  .foot-tips {
    margin-top: 40px;
    text-align: left;
    padding-left: 38px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    // line-height: 21px;
    color: #999999;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    span {
      margin-left: 5px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 21px;
      color: #1775e6;
    }
  }
}
.foot-btn {
  width: 345px;
  box-sizing: border-box;
  margin: 30px 15px 0;
  border-radius: 10px;
}
</style>
